import React from 'react';

export interface ChangeProp { name: string; from: unknown; to: unknown }
export interface Change { change: 'added' | 'removed' | 'modified' | 'moved' | 'reordered'; target: string; id?: string | null; label?: string | null; step?: string | null; properties?: ChangeProp[] }

const CHANGE_STYLE: Record<Change['change'], { sign: string; cls: string }> = {
  added: { sign: '+', cls: 'bg-emerald-100 text-emerald-700' },
  removed: { sign: '−', cls: 'bg-red-100 text-red-700' },
  modified: { sign: '~', cls: 'bg-amber-100 text-amber-700' },
  moved: { sign: '→', cls: 'bg-sky-100 text-sky-700' },
  reordered: { sign: '⇅', cls: 'bg-slate-100 text-slate-600' },
};

const fmt = (value: unknown): string => {
  if (value === null || value === undefined || value === '') return '∅';
  return typeof value === 'string' ? value : JSON.stringify(value);
};

export function ChangeList({ changes }: { changes: Change[] }) {
  return (
    <ul className="mt-1.5 space-y-1.5">
      {changes.map((c, i) => {
        const style = CHANGE_STYLE[c.change] || CHANGE_STYLE.modified;
        return (
          <li key={i} className="rounded-md border border-slate-100 bg-slate-50 px-2 py-1.5">
            <div className="flex flex-wrap items-center gap-1.5">
              <span className={`grid h-4 w-4 place-items-center rounded text-[10px] font-bold ${style.cls}`}>{style.sign}</span>
              <span className="text-[11px] font-medium capitalize text-slate-700">{c.change} {c.target}</span>
              {c.label && <span className="text-[11px] text-slate-700">“{c.label}”</span>}
              {c.id && c.id !== c.label && <span className="font-mono text-[10px] text-slate-400">{c.id}</span>}
              {c.step && <span className="text-[10px] text-slate-400">in {c.step}</span>}
            </div>
            {c.properties && c.properties.length > 0 && (
              <dl className="mt-1 space-y-0.5 pl-5">
                {c.properties.map((p) => (
                  <div key={p.name} className="flex flex-wrap items-baseline gap-1.5 text-[10px]">
                    <dt className="font-mono text-slate-500">{p.name}</dt>
                    <dd className="break-all text-red-600 line-through decoration-red-300">{fmt(p.from)}</dd>
                    <dd className="text-slate-400">→</dd>
                    <dd className="break-all text-emerald-700">{fmt(p.to)}</dd>
                  </div>
                ))}
              </dl>
            )}
          </li>
        );
      })}
    </ul>
  );
}
